import { overridable } from '@wix/santa-editor-utils';
import * as appStudioUtils from '../appStudio/appStudioUtils';

const getDsOrigin = overridable(() => {
  return appStudioUtils.isAppStudio() ? 'appBuilder' : 'Editor1.4';
});

export { getDsOrigin };
